'use client'
import Image from 'next/image'
import { formatUserName } from 'utils/format-user-name'
import type { PublicUserProfile } from 'codegen/types'

import { NEXT_PUBLIC_CF_URL } from '@web/utils/env'

export function UserAvatarLink({
  user,
}: {
  user?: Pick<PublicUserProfile, 'avatarUrl' | 'firstName' | 'lastName' | 'slug'> | null
}) {
  return (
    <div
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
        window.open(`${NEXT_PUBLIC_CF_URL}/crafter/${user?.slug}/`, '_blank')
      }}
      className="pointer-events-auto flex gap-2 items-center group overflow-hidden"
    >
      <Image
        alt={`${user?.firstName} ${user?.lastName}`}
        src={user?.avatarUrl || 'https://avatar.iran.liara.run/public/1'}
        width={20}
        height={20}
        className="rounded-full size-5"
      />
      <p className="text-12 text-cf-grey-1000 font-medium group-hover:underline truncate">
        {formatUserName(user?.firstName, user?.lastName, 'User')}
      </p>
    </div>
  )
}
